import { withDependencies, named } from '@wix/thunderbolt-ioc'
import { IViewerManagerImplementor, RenderFlags as DSRenderFlag } from 'thunderbolt-viewer-manager-types'
import type { DSCarmi } from 'thunderbolt-ds-carmi-root'
import type { ViewerManagerRenderFlagsApiEditorConfig } from './types'
import { CarmiInstance, EditorFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import { name } from './symbols'
import { RenderFlags } from '@wix/thunderbolt-becky-root'
import { Catharsis, CatharsisSymbol } from '@wix/thunderbolt-catharsis'

const viewerManagerRenderFlagsApiFactory = (
	{ carmiRenderFlags }: ViewerManagerRenderFlagsApiEditorConfig,
	{ renderFlags: setter }: DSCarmi,
	catharsis: Catharsis
): IViewerManagerImplementor<'renderFlags'> => {
	const renderFlags: DSRenderFlag = {
		hideSiteBackground: false,
		isComponentVisible: {},
		showControllers: false,
		isTinyMenuOpenAllowed: true,
		initWixCode: true,
		layoutMechanism: 'mesh',
		isPageProtectionEnabled: true,
		isSiteMembersDialogsOpenAllowed: false,
		enforceShouldKeepChildrenInPlace: true,
		shouldKeepTPAComps: true,
		...carmiRenderFlags,
	}

	return {
		renderFlags: {
			setRenderFlag: <Key extends keyof DSRenderFlag>(flagName: Key, flagValue: DSRenderFlag[Key]) => {
				if (carmiRenderFlags.hasOwnProperty(flagName)) {
					if (flagValue === undefined) {
						// setting to undefined will remove it from carmi flags
						return
					}

					setter.setRenderFlag(flagName as keyof RenderFlags, flagValue as RenderFlags[keyof RenderFlags])

					catharsis.transaction(({ updateEnvironment }) =>
						updateEnvironment({ renderFlags: { [flagName]: flagValue } })
					)
				}

				renderFlags[flagName] = flagValue
			},
			getRenderFlags: (): DSRenderFlag => renderFlags,
		},
	}
}
export const ViewerManagerRenderFlagsApi = withDependencies(
	[named(EditorFeatureConfigSymbol, name), CarmiInstance, CatharsisSymbol],
	viewerManagerRenderFlagsApiFactory
)
